module.exports = __webpack_public_path__ + "img/member_card_4.a594ed89.png";